<template>
  <section>
  <b-input v-if="valueIsObj" v-model="value.data" />
  <b-input v-else :value="value" @input="onInput"/>
  </section>
</template>

<script>
export default {
  name: 'c-field',
  props: ['value', 'type'],
  computed: {
    valueIsObj() {
      return typeof this.value === 'object'
    },
  },
  methods: {
    onInput(value) {
      switch (this.type) {
        case 'integer':
          this.$emit('input', parseInt(value))
          break
        default:
          this.$emit('input', value)
      }
    },
  },
}
</script>



// WEBPACK FOOTER //
// src/lib/components/Input.vue